import { config as platformConfig } from '@shopee-user/platform';

export const THIRDPARTY_OAUTH_CONTEXT_KEY = `${platformConfig.BUSINESS_TARGET}_THIRDPARTY_OAUTH_CONTEXT`;
